import { ChangeDetectionStrategy, Component, inject, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeSl from '@angular/common/locales/sl';
import { HlmToasterImports } from '@spartan-ng/helm/sonner';
import { UserStore } from './core/stores/user.store';
import { UsersService } from './core/services/users.service';
registerLocaleData(localeSl);

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HlmToasterImports],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: LOCALE_ID, useValue: 'sl-SI' }],
})
export class App {
  private userService = inject(UsersService);
  private userStore = inject(UserStore);

  constructor() {
    if (this.userStore.userId()) {
      this.userService.getUserById(this.userStore.userId()!).subscribe({
        next: (user) => this.userStore.setUser(user),
        error: (err) => {
          console.error('Error fetching user data:', err);
          this.userStore.clear();
        },
      });
    }
  }
}
